export default __webpack_public_path__ + "static/media/ic_check_48px.10aeba44.svg";